import { TemplateRef } from '@angular/core';
import { ApiResponse } from '@app/infrastructure/data-list/grid/api-grid/api';
import { IFilters } from '@app/infrastructure/data-list/grid/api-grid-filters/filters';
import { IWidgetState } from '@app/infrastructure/state-switcher/state-switcher.model';
import { Observable } from 'rxjs';

export const DEFAULT_GRID_STATE: IWidgetState = { isLoading: true, isEmpty: true, isError: false };

export enum GridType {
	default = 'is-default',
	likeMaterial = 'is-like-material',
	likePS = 'is-like-ps',
	withTotalRow = 'is-total-row',
}

export type RowCustomClassesFn<T = unknown> = (rowData: T | null) => string;

export interface IRowConfig<T> {
	id: string;
	data: T | null;
	customTmpl?: TemplateRef<unknown>;
	collapsibleTemplateRef?: TemplateRef<unknown>;
}

export enum ICustomCells {
	date = 'cellDate',
	simple = 'cellSimple',
	percentage = 'cellPercentage',
	price = 'cellPrice',
	boolean = 'cellBoolean',
}

export enum ICustomHeader {
	action = 'headerAction',
	simple = 'headerSimple',
	sorting = 'headerSorting',
}

export enum TemplateTypes {
	inner = 'innerCustom',
	outer = 'outerCustom',
}

export type ItemIdentityFn<T> = (index: number, item: T) => string | number;

export const idIdentityFn: ItemIdentityFn<{ id: string }> = (_index: number, { id }: { id: string }) => id;
export const identityByPropFn =
	<T>(prop: keyof T) =>
	(value: T) =>
		value[prop];

export interface Grid<DataType, FilterType> {
	identityFn: ItemIdentityFn<any>;
	filters: IFilters<FilterType>;
	changes(): Observable<ApiResponse<DataType>>;
	setSlice(page: number | string, amount: number): void;
	stateChanges(): Observable<IWidgetState>;
}
